import * as React from 'react';
import styled from 'styled-components';

import { Icon, IconStyled } from '@longline/aqua-ui/controls/Icon';
import { SVG } from '@longline/aqua-ui/svg';

interface IProps {
  className?: string;
  visible: boolean;
  onClick?: () => void;
}

const EyeIconBase = (props: IProps) => {

  // Keep track of visibile status internally, so that the icon updates 
  // immediately on click.
  const [visible, setVisible] = React.useState(props.visible);

  React.useEffect(() => {
    setVisible(props.visible);
  }, [props.visible]);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setVisible(!visible);
    // Give React a chance to rerender this control:
    setTimeout(() => props.onClick?.(), 0);
  }

  // Both icons are rendered at the same time, with one hidden using CSS.
  // The reason is that React takes too long to update, leaving a missing
  // icon for a brief period of time.
  return (
    <div className={props.className} onClick={handleClick}>
      <IconHolder style={{ display: visible ? 'flex' : 'none'}}>
        <Icon title="Layer is visible" url={SVG.Icons.Eye}/>
      </IconHolder>
      <IconHolder style={{ display: !visible ? 'flex' : 'none'}}>
        <Icon title="Layer is hidden" url={SVG.Icons.EyeClosed}/>
      </IconHolder>
    </div>
  );
}

const IconHolder = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const EyeIcon = styled(EyeIconBase)`
  position: relative;
  cursor: pointer;
  width: 24px;
  height: 24px;
  border-radius: 50%;

  ${IconStyled} {
    fill: ${p => p.visible ? '#fff' : '#ddd'};
  }

  background-color: ${p => p.theme.colors.primary[5]};
  transition: background-color ease-in-out 0ms;
  &:hover {
    background-color: ${p => p.theme.colors.primary[2]};
  }
`

export { EyeIcon }
